export default __webpack_public_path__ + "static/media/help.96a31865.svg";